var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { normalizeObject, dataLayerPush, toEhashAsync } from "../shared/utils";
var myAccountEventsHandler = function (e) {
    var baseResetData = {
        non_interaction: false,
        event_errors: 0,
        total_errors: 0
    };
    var myAccountEventData = e && e.detail
        && Object.assign({}, baseResetData, normalizeObject(e.detail));
    var email = myAccountEventData["email"];
    (function () { return __awaiter(void 0, void 0, void 0, function () {
        var ehash, eventKey, accountData, accountData, accountData, accountData;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, toEhashAsync(email).catch(function (err) {
                        // TODO: Implement Logger
                        console.log(err);
                        return "";
                    })];
                case 1:
                    ehash = _a.sent();
                    // remove email from data
                    delete myAccountEventData["email"];
                    eventKey = e === null || e === void 0 ? void 0 : e.type;
                    if (eventKey === "account_lookup") {
                        accountData = Object.assign({}, normalizeObject(__assign(__assign({}, myAccountEventData), { event: "my_account_login_page_interactions", event_action: "account_lookup", event_category: "create" })));
                        dataLayerPush(accountData);
                    }
                    if (eventKey === "create_account_vpv") {
                        accountData = Object.assign({}, normalizeObject(__assign(__assign({}, myAccountEventData), { event: "page_view", page_display_type: "vpv", non_interaction: true })));
                        dataLayerPush(accountData);
                    }
                    if (eventKey === "create_account_success") {
                        accountData = Object.assign({}, normalizeObject(__assign(__assign({}, myAccountEventData), { event: "my_account_login_page_interactions", event_action: "create_account_success", event_category: "create", ehash: ehash, ret_login_success: true, retain_interactions: true })));
                        dataLayerPush(accountData);
                    }
                    if (eventKey === "create_account_error") {
                        accountData = Object.assign({}, normalizeObject(__assign(__assign({}, myAccountEventData), { event: "my_account_login_page_interactions", event_action: "create_account_error", event_category: "create", event_errors: 1, total_errors: 1, non_interaction: true })));
                        dataLayerPush(accountData);
                    }
                    return [2 /*return*/];
            }
        });
    }); })();
};
export { myAccountEventsHandler };
